import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carousel, CarouselContent, CarouselNext, CarouselPrevious, CarouselSlot, Stack, Thumbnail, } from '@yonderland/andes-react';
import { getImageFromCdn } from '../../util/ImageUtil';
export const GiftVoucherThumbSlider = ({ images, imageCdnPrefix, activeSlideIndex, setApi, onThumbClick, }) => {
    const handleClick = (index) => () => {
        onThumbClick(index);
    };
    const renderSlide = (slide, index) => {
        const imagePath = getImageFromCdn(slide, imageCdnPrefix);
        return (_jsx(CarouselSlot, { children: _jsx(Thumbnail, { image: {
                    source: imagePath,
                    alt: `gift_voucher_thumb_${index}`,
                }, ratio: "3/4", hasBorder: true, state: activeSlideIndex === index ? 'active' : 'resting', onClick: handleClick(index) }) }, `gift_voucher_thumb_${index}`));
    };
    return (_jsx(Carousel, { testId: "gift_voucher_thumb_slider", slideSize: 96, hideOverflow: true, setApi: setApi, children: _jsxs(Stack, { direction: "col", gap: "4", children: [_jsx(CarouselContent, { children: images.map(renderSlide) }), _jsxs(Stack, { gap: "1", children: [_jsx(CarouselPrevious, {}), _jsx(CarouselNext, {})] })] }) }));
};
